import React, { FC, useState } from "react";
import css from "./styles.module.scss";
import { Button } from "@mui/material";
import { geoItem } from "../CountryCode/types";

interface IFeedBackBlockProps {
  value: geoItem;
}

const FeedBackBlock: FC<IFeedBackBlockProps> = ({value}) => {
  const [openFeedback, setOpenFeedback] = useState(false);
  return (
    <div className={css.feedBackBlock}>
      <Button
        variant="contained"
        size="small"
        color="success"
        onClick={() => setOpenFeedback(!openFeedback)}
      >
        {`${openFeedback ? "Скрыть" : "Показать"} фидбек`}
      </Button>
      {openFeedback && (
        <div className={css.feedBackBlock_text}>
          {`
               <style>
      :root {
        --bgColor: #ffc000;
        --textColor: #000;
      }
      .feedback {
        width: 75px;
        height: 70px;
        position: fixed;
        right: -15px;
        top: 15%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bgColor);
        border-top-left-radius: 35px;
        border-bottom-left-radius: 35px;
        cursor: pointer;
        z-index: 1000;
        box-shadow: -2px 3px 11px rgb(0 0 0 / 30%);
        transition: all 0.5s;
      }
      .feedback:hover {
        right: 0;
      }
      .feedback img {
        width: 50px;
        height: 50px;
      }
      .popup-window {
        font-family: sans-serif;
        font-family: inherit;
        display: none;
        width: 300px;
        position: fixed;
        right: 0;
        top: 15%;
        padding: 35px 10px;
        background: #fff;
        border-radius: 5px 0 0 5px;
        z-index: 2000;
        box-shadow: -2px 3px 11px rgb(0 0 0 / 17%);
      }
      .popup-window form {
        width: 100%;
        min-height: auto;
        padding: 0;
        background: inherit;
        box-shadow: none;
        height: auto;
      }
      .popup-window label {
        display: block;
        margin-bottom: 5px;
        font-size: 14px;
        color: #333;
        text-transform: uppercase;
      }
      .popup-window input {
        box-sizing: border-box;
        width: 100%;
        height: auto;
        margin-bottom: 10px;
        padding: 10px;
        border: none;
        font-family: inherit;
        font-size: 16px;
        margin-bottom: 15px;
        border: 1px solid #333;
      }
      .popup-window input::placeholder {
        font-size: 16px;
      }
      .popup-window button {
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 5px;
        background: var(--bgColor);
        color: var(--textColor);
        cursor: pointer;
        font-family: inherit;
        font-size: 16px;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 15px;
        border-radius: 20px;
      }
      .close-popup {
        position: absolute;
        right: 10px;
        top: 5px;
        width: 27px;
        height: 27px;
        background-color: #fff;
        cursor: pointer;
      }
      .close-popup:before {
        content: "";
        background: #333;
        width: 20px;
        height: 1px;
        position: absolute;
        top: 13px;
        left: 4px;
        transform: rotate(-45deg);
      }
      .close-popup:after {
        content: "";
        background: #333;
        width: 20px;
        height: 1px;
        position: absolute;
        top: 13px;
        left: 4px;
        transform: rotate(45deg);
      }

      @media screen and (max-width: 576px) {
        .feedback {
          top: 35%;
        }
        .popup-window {
          top: 35%;
        }
      }
    </style>
          <div class="feedback">
          <img src="img/i-phone.png" alt="" />
        </div>
        <div class="popup-window">
          <div class="close-popup"></div>
          <form method="POST" action="">
            <label for="name2">${value.nameLabel}</label>
            <input
              id="name2"
              type="text"
              name="name"
              placeholder="${value.namePlaceholder}"
              required
            />
            <label for="phone2">${value.phoneLabel}</label>
            <input
              id="phone2"
              type="tel"
              name="phone"
              placeholder="${value.phonePlaceholder}"
              required
            />
            <button type="submit">${value.buttonSumbitText}</button>
          </form>
        </div>
    <script>
      document.addEventListener("DOMContentLoaded", () => {
        const popup = document.querySelector(".popup-window");
        document
          .querySelector(".feedback")
          ?.addEventListener("click", () => (popup.style.display = "block"));
        document
          .querySelector(".close-popup")
          ?.addEventListener("click", () => (popup.style.display = "none"));
      });
    </script>
            `}
        </div>
      )}
    </div>
  );
};

export default FeedBackBlock;
